import { EmbedBlot } from 'parchment';
import { Quill } from 'react-quill-new';

export const SOFT_BREAK = 'SoftBreak';
export class SoftBreak extends EmbedBlot {
  static blotName = SOFT_BREAK;
  static tagName = 'br';
}

export const lineBreakMatcher = (_, delta) => {
  delta.ops = [{ insert: { [SOFT_BREAK]: '' } }];
  return delta;
};

export function lineBreakHandler(range) {
  const [currentLeaf] = this.quill.getLeaf(range.index);
  const [nextLeaf] = this.quill.getLeaf(range.index + 1);

  // add 'break' blot which we defined inside the setup func
  this.quill.insertEmbed(range.index, SOFT_BREAK, true, Quill.sources.USER);

  // Insert a second break if:
  // At the end of the text area, OR next leaf has a different parent.
  if (nextLeaf === null || currentLeaf.parent !== nextLeaf.parent) {
    this.quill.insertEmbed(range.index, SOFT_BREAK, true, Quill.sources.USER);
  }

  // move the cursor forward
  this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
}
